module.exports = __webpack_public_path__ + "static/media/Seetings_Icon.38191817.svg";